import { Alert, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { colors, layout } from '../NewHire/v2/styles';
import { AnnualReviewResponse } from './types';

interface WaitingFinanceCardProps {
  review: AnnualReviewResponse;
}

const WaitingFinanceCard = ({ review }: WaitingFinanceCardProps) => {
  const history = useHistory();
  return (
    <div>
      <h1 style={{ ...layout.title, marginBottom: 4 }}>Waiting for Finance Approval</h1>
      <p style={layout.subtitle as any}>
        {review.employeeName}'s annual review is on hold while Finance reviews the pay raise request.
      </p>

      <Alert color="warning" className="mt-3">
        <i className="fas fa-hourglass-half mr-2" />
        Once Finance approves or denies, the combined PDF will be automatically updated with the final decision and the
        next step (signatures + upload) will become available. You'll see the update on this page or by re-opening from
        Performance Management.
      </Alert>

      <div style={{ marginTop: 24, padding: 14, background: '#f9fafb', borderRadius: 8 }}>
        <p style={{ margin: 0, fontSize: 13, color: colors.muted }}>
          <strong>Cycle:</strong> {review.cycleYear} &nbsp;·&nbsp;
          <strong>Proposed increase:</strong>{' '}
          {review.proposedPayRate?.increasePercent != null ? `${review.proposedPayRate.increasePercent}%` : '—'}{' '}
          &nbsp;·&nbsp;
          <strong>Proposed new pay:</strong>{' '}
          {review.proposedPayRate?.newPayRate != null
            ? `$${Number(review.proposedPayRate.newPayRate).toFixed(2)}`
            : '—'}
        </p>
      </div>

      <div style={{ marginTop: 24 }}>
        <Button color="secondary" onClick={() => history.push('/performance-management')}>
          Back to Performance Management
        </Button>
      </div>
    </div>
  );
};

export default WaitingFinanceCard;
